import styled from 'styled-components';

export const Logo = styled.img`
    width: 40px;
    height: 40px;
}
`;
